var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMidVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.8137V15.0049C5 15.5812 5.47152 16.0527 6.04781 16.0527H9.19126L12.6386 19.5C13.2987 20.1602 14.4303 19.6887 14.4303 18.7561V7.05202C14.4303 6.11946 13.2987 5.64795 12.6386 6.30807L9.19126 9.76586H6.04781C5.47152 9.76586 5 10.2374 5 10.8137Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6416 12.9093C17.6414 12.0314 17.4541 11.1709 17.1008 10.4249C16.7474 9.67886 16.2421 9.07684 15.6416 8.68665V17.1215C16.8256 16.3566 17.6416 14.7639 17.6416 12.9093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMidVolume);
export default __webpack_public_path__ + "static/media/ic_mid_volume.a4be39a1ce9259dca5d2ea3e93e0ad2d.svg";
export { ForwardRef as ReactComponent };